import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Menu.scss';
import '../../resources/main.scss';

const Menu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState(['products', 'receptions', 'necessities', 'providers']); // toate deschise

  const toggleMenu = (menu) => {
    setOpenMenus((prevOpenMenus) =>
      prevOpenMenus.includes(menu)
        ? prevOpenMenus.filter((m) => m !== menu)
        : [...prevOpenMenus, menu]
    );
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const getSelectedKey = () => {
    const pathname = location.pathname;
    const routeToKey = {
      '/products': 'products',
      '/import-products': 'import-products',
      '/search-product': 'products',
      '/receptii': 'receptii',
      '/import-receptions': 'import-receptions',
      '/liste-necesar': 'liste-necesar',
      '/gata-de-trimis': 'liste-necesar',
      '/liste-in-ofertare': 'liste-necesar',
      '/liste-ofertate': 'liste-necesar',
      '/liste-arhivate': 'liste-necesar',
      '/import-lista-necesar': 'import-lista-necesar',
      '/furnizori': 'furnizori',
      '/adauga-furnizor': 'adauga-furnizor',
    };
    
    // Check for exact match first
    if (routeToKey[pathname]) {
      return routeToKey[pathname];
    }
    
    // Check for paths that start with certain prefixes
    if (pathname.startsWith('/product/')) {
      return 'products';
    }
    
    if (pathname.startsWith('/lists/')) {
      return 'liste-necesar';
    }
    
    return routeToKey[pathname];
  };

  const selectedKey = getSelectedKey();

  return (
    <div className='menu__wrapper standard hp'>
      <div className="menu__mobile-header"></div>
      <div className='menu'>
        <div className='menu__links-wrapper'>

          {/* Produse */}
          <div className={`menu__item-box ${openMenus.includes('products') ? 'open' : ''}`}>
            <div className="menu__main-link" onClick={() => toggleMenu('products')}>
              <h4 className='menu__link'>Produse</h4>
              <img
                src={openMenus.includes('products') ? '/images/up.png' : '/images/down.png'}
                alt="toggle"
                className="menu__icon-arrow"
              />
            </div>
            {openMenus.includes('products') && (
              <div className="menu__sub-links">
                <div className={`menu__sub-link ${selectedKey === 'products' ? 'active' : ''}`} onClick={() => handleNavigation('/products')}>
                  <img src='/images/submenu-1.png' alt='submenu' />
                  <h5>Listă produse</h5>
                </div>
                <div className={`menu__sub-link ${selectedKey === 'import-products' ? 'active' : ''}`} onClick={() => handleNavigation('/import-products')}>
                  <img src='/images/submenu-2.png' alt='submenu' />
                  <h5>Import produse</h5>
                </div>
              </div>
            )}
          </div>

          {/* Recepții */}
          <div className={`menu__item-box ${openMenus.includes('receptions') ? 'open' : ''}`}>
            <div className="menu__main-link" onClick={() => toggleMenu('receptions')}>
              <h4 className='menu__link'>Recepții</h4>
              <img
                src={openMenus.includes('receptions') ? '/images/up.png' : '/images/down.png'}
                alt="toggle"
                className="menu__icon-arrow"
              />
            </div>
            {openMenus.includes('receptions') && (
              <div className="menu__sub-links">
                <div className={`menu__sub-link ${selectedKey === 'receptii' ? 'active' : ''}`} onClick={() => handleNavigation('/receptii')}>
                  <img src='/images/submenu-1.png' alt='submenu' />
                  <h5>Listă recepții</h5>
                </div>
                <div className={`menu__sub-link ${selectedKey === 'importa-receptie' ? 'active' : ''}`} onClick={() => handleNavigation('/import-receptions')}>
                  <img src='/images/submenu-2.png' alt='submenu' />
                  <h5>Import recepții</h5>
                </div>
              </div>
            )}
          </div>

          {/* Necesar */}
          <div className={`menu__item-box ${openMenus.includes('necessities') ? 'open' : ''}`}>
            <div className="menu__main-link" onClick={() => toggleMenu('necessities')}>
              <h4 className='menu__link'>Necesar</h4>
              <img
                src={openMenus.includes('necessities') ? '/images/up.png' : '/images/down.png'}
                alt="toggle"
                className="menu__icon-arrow"
              />
            </div>
            {openMenus.includes('necessities') && (
              <div className="menu__sub-links">
                <div className={`menu__sub-link ${selectedKey === 'liste-necesar' ? 'active' : ''}`} onClick={() => handleNavigation('/liste-necesar')}>
                  <img src='/images/submenu-1.png' alt='submenu' />
                  <h5>Liste necesar</h5>
                </div>
                <div className={`menu__sub-link ${selectedKey === 'import-lista-necesar' ? 'active' : ''}`} onClick={() => handleNavigation('/import-lista-necesar')}>
                  <img src='/images/submenu-2.png' alt='submenu' />
                  <h5>Import liste necesar</h5>
                </div>
              </div>
            )}
          </div>

          {/* Furnizori */}
          <div className={`menu__item-box ${openMenus.includes('providers') ? 'open' : ''}`}>
            <div className="menu__main-link" onClick={() => toggleMenu('providers')}>
              <h4 className='menu__link'>Furnizori</h4>
              <img
                src={openMenus.includes('providers') ? '/images/up.png' : '/images/down.png'}
                alt="toggle"
                className="menu__icon-arrow"
              />
            </div>
            {openMenus.includes('providers') && (
              <div className="menu__sub-links">
                <div className={`menu__sub-link ${selectedKey === 'furnizori' ? 'active' : ''}`} onClick={() => handleNavigation('/furnizori')}>
                  <img src='/images/submenu-1.png' alt='submenu' />
                  <h5>Listă furnizori</h5>
                </div>
                <div className={`menu__sub-link ${selectedKey === 'adauga-furnizor' ? 'active' : ''}`} onClick={() => handleNavigation('/adauga-furnizor')}>
                  <img src='/images/submenu-2.png' alt='submenu' />
                  <h5>Adaugă furnizor</h5>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Menu;
